var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 56.6667C17.4619 56.6667 10 49.2047 10 40C10 31.8385 15.8664 25.0471 23.6125 23.6125C25.0471 15.8664 31.8385 10 40 10C48.1615 10 54.9529 15.8664 56.3875 23.6125C64.1336 25.0471 70 31.8385 70 40C70 49.2047 62.5381 56.6667 53.3333 56.6667M30 40L40 30M40 30L50 40M40 30V70",
    stroke: "#4318FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.76e905233a962d9fa73920b6ee527974.svg";
export { ForwardRef as ReactComponent };